import styled from "styled-components";

export const PseudoLink = styled.span`
font-size: 18px;
font-weight: 500;
gap: 8px;
display: flex;
align-items: center;
color: #5C5AD6;
margin-top: auto;
margin-inline: auto;
transition: color var(--transition-speed) ease-in-out;

svg{
  width: 24px;
  height: 24px;
  transform: translateX(0);
  transition: transform var(--transition-speed) ease-in-out;
}
`

export const CardContainer = styled.div`
  --transition-speed: 200ms;
  border-radius: 12px;
  overflow: hidden;
  padding: 44px 32px 40px;
  background-color: #FFF;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  z-index:0;
  transition: background-color var(--transition-speed) ease-in-out, color var(--transition-speed) ease-in-out;
  
  &.active, &:hover{
    background-color: #5C5AD6;
    color: #fff;
    * {
      color: #fff;
    }

    .heading{
      color: #fff;
    }

    ${PseudoLink}{
      color: #fff;

      svg{
        transform: translateX(4px);
      }
    }
  }

  .heading{
    transition: color var(--transition-speed) ease-in-out;
  }

  .description {
    &:not(:last-child){
      margin-bottom: 24px;  
    }
  }
`

export const CardLink = styled.a`
  text-decoration: none;
  margin-bottom: 20px;

  &::before{
    content: "";
    display: block;
    position: absolute;
    inset: 0;
    z-index: 1;
  }
`

